import { render, staticRenderFns } from "./VTagsGroup.vue?vue&type=template&id=60f034f4&"
import script from "./VTagsGroup.vue?vue&type=script&lang=ts&"
export * from "./VTagsGroup.vue?vue&type=script&lang=ts&"
import style0 from "./VTagsGroup.vue?vue&type=style&index=0&id=60f034f4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports